module.exports = __webpack_public_path__ + "videos/metrics.bb4769e.webm";